"use client";

import { CookieSettingsButton } from "@/components/CookieConsent";
import { useCookieDictionary } from "@/lib/cookies/useCookieDictionary";
import { Mail } from "lucide-react";
import { useLocale, useTranslations } from "next-intl";
import Link from "next/link";

export function Footer() {
  const t = useTranslations("footer");
  const locale = useLocale();
  const cookieDictionary = useCookieDictionary();

  return (
    <footer className="bg-charcoal text-white-cream py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div>
            <span className="text-2xl font-bold font-serif">
              {t("companyName")}
            </span>
            <p className="text-white-cream/60 text-sm mt-2">{t("tagline")}</p>
          </div>
          <div className="text-center md:text-right">
            <p className="text-white-cream/60 text-sm">
              © {new Date().getFullYear()} {t("companyName")}. {t("copyright")}
            </p>
            <div className="flex items-center justify-center md:justify-end gap-3 mt-2">
              <Link
                href={`/${locale}/mentions-legales`}
                className="text-white-cream/60 hover:text-terracotta-light text-sm transition-colors"
              >
                {t("legalNotice")}
              </Link>
              <span className="text-white-cream/60">·</span>
              <CookieSettingsButton
                dictionary={cookieDictionary}
                className="text-white-cream/60 hover:text-terracotta-light"
              />
            </div>
            <p className="text-white-cream/60 text-xs mt-2 flex items-center justify-center md:justify-end gap-1 flex-wrap">
              <span>{t("createdBy")}</span>
              <a
                href="https://www.julesdupuis.fr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-terracotta-light hover:text-terracotta transition-colors"
              >
                Jules Dupuis
              </a>
              <span>·</span>
              <a
                href="mailto:contact@julesdupuis.fr"
                className="text-terracotta-light hover:text-terracotta transition-colors inline-flex items-center gap-1"
              >
                <Mail className="w-3 h-3" />
                contact@julesdupuis.fr
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
